import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa3164a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cc-result" }
const _hoisted_2 = { class: "cc-result__summary" }
const _hoisted_3 = { class: "cc-result__eyebrow" }
const _hoisted_4 = { class: "cc-result__headline" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-arrow-right",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "cc-result__meta" }
const _hoisted_7 = { class: "cc-chip cc-chip--primary" }
const _hoisted_8 = {
  key: 0,
  class: "cc-notice"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-info-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = { class: "cc-result__section-title" }
const _hoisted_11 = { class: "cc-result__section-text" }
const _hoisted_12 = {
  key: 1,
  class: "cc-notice cc-notice--success"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trophy",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = { class: "cc-roadmap" }
const _hoisted_15 = {
  class: "cc-roadmap__marker",
  "aria-hidden": "true"
}
const _hoisted_16 = {
  key: 0,
  class: "bi bi-check-lg"
}
const _hoisted_17 = { class: "cc-pathway" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "cc-pathway__info" }
const _hoisted_20 = { class: "cc-pathway__chips" }
const _hoisted_21 = {
  key: 0,
  class: "cc-chip cc-chip--primary"
}
const _hoisted_22 = {
  key: 1,
  class: "cc-chip cc-chip--success"
}
const _hoisted_23 = {
  key: 2,
  class: "cc-chip"
}
const _hoisted_24 = { class: "cc-chip" }
const _hoisted_25 = { class: "cc-pathway__name" }
const _hoisted_26 = {
  key: 0,
  class: "cc-pathway__description"
}
const _hoisted_27 = {
  key: 1,
  class: "cc-pathway__progress"
}
const _hoisted_28 = { class: "cc-bar" }
const _hoisted_29 = {
  key: 2,
  class: "cc-complement"
}
const _hoisted_30 = { class: "cc-result__section-title" }
const _hoisted_31 = { class: "cc-result__section-text" }
const _hoisted_32 = { class: "cc-pathway" }
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = { class: "cc-pathway__info" }
const _hoisted_35 = { class: "cc-pathway__chips" }
const _hoisted_36 = {
  key: 0,
  class: "cc-chip cc-chip--success"
}
const _hoisted_37 = { class: "cc-pathway__name" }
const _hoisted_38 = {
  key: 0,
  class: "cc-pathway__description"
}
const _hoisted_39 = { class: "cc-insights" }
const _hoisted_40 = { class: "cc-insight" }
const _hoisted_41 = { class: "cc-result__section-title" }
const _hoisted_42 = { class: "cc-insight__text" }
const _hoisted_43 = { class: "cc-insight" }
const _hoisted_44 = { class: "cc-result__section-title" }
const _hoisted_45 = { class: "cc-insight__text" }
const _hoisted_46 = { class: "cc-insight__text" }
const _hoisted_47 = { class: "cc-result__section-title" }
const _hoisted_48 = { class: "cc-steps" }
const _hoisted_49 = { class: "cc-notice cc-notice--warning" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-shield-exclamation",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_51 = { class: "cc-result__footer" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1))

import { computed } from "vue";
import { CareerCompassPathway, CareerCompassResult } from "@/modern/types/careerCompass";
import { useCareerCompassI18n } from "@/modern/components/careerCompass/careerCompassI18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    result: null
  },
  emits: ["redo", "navigate"],
  setup(__props: any, { emit }: { emit: ({ (e: "redo"): void; (e: "navigate"): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { result: CareerCompassResult }




const { tc, lang } = useCareerCompassI18n();

const LOCALES: Record<string, string> = { pt: "pt-BR", en: "en-US", es: "es-ES" };
const FIRST_STEPS = ["step_1", "step_2", "step_3", "step_4"];

const profileKey = computed(() => `profiles.${props.result.profile}`);
const goalLabel = computed(() => tc(`goals.${props.result.goal}`));
const answeredAt = computed(() =>
  new Date(props.result.created_at).toLocaleDateString(LOCALES[lang.value] || "en-US")
);
const allDone = computed(() => props.result.roadmap.length > 0 && props.result.roadmap.every((pathway) => pathway.completed));

const pathwayHref = (pathway: CareerCompassPathway) => `/training/learning-paths/${pathway.id}`;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(tc)("result.eyebrow")), 1),
      _createElementVNode("h3", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(tc)(`${_unref(profileKey)}.label`)) + " ", 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_unref(goalLabel)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(tc)(`levels.${__props.result.level}`)), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(tc)("result.done_at", { date: _unref(answeredAt) })), 1)
      ])
    ]),
    (__props.result.uncovered)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_unref(tc)("result.uncovered", { goal: _unref(goalLabel) })), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", _hoisted_10, _toDisplayString(_unref(tc)("result.roadmap_title")), 1),
    _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(tc)("result.roadmap_text")), 1),
    (_unref(allDone))
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_unref(tc)("result.all_done")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ol", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result.roadmap, (pathway, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: pathway.id,
          class: _normalizeClass(["cc-roadmap__item", {
          'cc-roadmap__item--start': pathway.id === __props.result.start_pathway_id,
          'cc-roadmap__item--optional': pathway.below_level && !pathway.completed,
        }])
        }, [
          _createElementVNode("span", _hoisted_15, [
            (pathway.completed)
              ? (_openBlock(), _createElementBlock("i", _hoisted_16))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_17, [
            (pathway.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: pathway.image,
                  alt: pathway.name,
                  class: "cc-pathway__image"
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (pathway.id === __props.result.start_pathway_id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(tc)("result.start_here")), 1))
                  : _createCommentVNode("", true),
                (pathway.completed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(tc)("result.completed")), 1))
                  : (pathway.below_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(tc)("result.below_level")), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(tc)(`levels.${pathway.level}`)), 1)
              ]),
              _createElementVNode("p", _hoisted_25, _toDisplayString(pathway.name), 1),
              (pathway.short_description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(pathway.short_description), 1))
                : _createCommentVNode("", true),
              (!pathway.completed && pathway.percentage > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", {
                        class: "cc-bar__value",
                        style: _normalizeStyle({ width: `${pathway.percentage}%` })
                      }, null, 4)
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_unref(tc)("result.progress", { percentage: pathway.percentage })), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, {
              to: pathwayHref(pathway),
              class: _normalizeClass(["lp-btn cc-pathway__open", { 'lp-btn--outline': pathway.id !== __props.result.start_pathway_id }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('navigate')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(tc)("result.open")), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ])
        ], 2))
      }), 128))
    ]),
    (__props.result.complement)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("h4", _hoisted_30, _toDisplayString(_unref(tc)("result.complement_title")), 1),
          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(tc)("result.complement_text")), 1),
          _createElementVNode("div", _hoisted_32, [
            (__props.result.complement.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.result.complement.image,
                  alt: __props.result.complement.name,
                  class: "cc-pathway__image"
                }, null, 8, _hoisted_33))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                (__props.result.complement.completed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(tc)("result.completed")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_37, _toDisplayString(__props.result.complement.name), 1),
              (__props.result.complement.short_description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(__props.result.complement.short_description), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, {
              to: pathwayHref(__props.result.complement),
              class: "lp-btn lp-btn--outline cc-pathway__open",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('navigate')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(tc)("result.open")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("h4", _hoisted_41, _toDisplayString(_unref(tc)("result.brings_title")), 1),
        _createElementVNode("p", _hoisted_42, _toDisplayString(_unref(tc)(`${_unref(profileKey)}.brings`)), 1)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("h4", _hoisted_44, _toDisplayString(_unref(tc)("result.leaps_title")), 1),
        _createElementVNode("p", _hoisted_45, [
          _createElementVNode("strong", null, _toDisplayString(_unref(tc)("result.technical")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_unref(tc)(`${_unref(profileKey)}.technical_leap`)), 1)
        ]),
        _createElementVNode("p", _hoisted_46, [
          _createElementVNode("strong", null, _toDisplayString(_unref(tc)("result.behavioral")) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_unref(tc)(`${_unref(profileKey)}.behavioral_leap`)), 1)
        ])
      ])
    ]),
    _createElementVNode("h4", _hoisted_47, _toDisplayString(_unref(tc)("result.first_steps_title")), 1),
    _createElementVNode("ol", _hoisted_48, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FIRST_STEPS, (step) => {
        return _createElementVNode("li", { key: step }, _toDisplayString(_unref(tc)(`${_unref(profileKey)}.${step}`)), 1)
      }), 64))
    ]),
    _createElementVNode("p", _hoisted_49, [
      _hoisted_50,
      _createElementVNode("span", null, _toDisplayString(_unref(tc)("result.ethics")), 1)
    ]),
    _createElementVNode("footer", _hoisted_51, [
      _createElementVNode("button", {
        type: "button",
        class: "lp-btn lp-btn--outline",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('redo')))
      }, [
        _hoisted_52,
        _createTextVNode(" " + _toDisplayString(_unref(tc)("result.redo")), 1)
      ])
    ])
  ]))
}
}

})